declare class BitTheme {
    static init(options: BitThemeOptions): void;
    static getCurrentTheme(): string | null;
}

interface BitThemeOptions {
    system?: boolean;
    persist?: boolean;
    theme?: string | null;
    default?: string | null;
    darkTheme?: string | null;
    lightTheme?: string | null;
    onChange?: onThemeChangeType;
}

type onThemeChangeType = (newThemeName: string, oldThemeName: string) => void;

function applyTheme(themeName: string) {
    document.body.classList.add('theme-' + themeName);

    const primaryBgColor = getComputedStyle(document.documentElement).getPropertyValue('--bit-clr-bg-pri');
    if (primaryBgColor) {
        document.querySelector('meta[name=theme-color]')?.setAttribute('content', primaryBgColor);
    }
}

function updateLogosBasedOnDomain() {
    const isCrystaLive = window.location.href.includes('crysta.live');
    const domainClass = isCrystaLive ? 'crystalive' : 'crystacode';

    document.body.classList.remove('crystacode', 'crystalive');
    document.body.classList.add(domainClass);
}

document.addEventListener('DOMContentLoaded', () => {
    updateLogosBasedOnDomain();

    BitTheme?.init({
        default: 'dark',
        persist: true,
        onChange: (newTheme: string, oldTheme: string) => {
            document.body.classList.remove('theme-' + oldTheme);
            applyTheme(newTheme);
        }
    });

    setTimeout(() => {
        const currentTheme = BitTheme?.getCurrentTheme?.();
        if (currentTheme) {
            applyTheme(currentTheme);
        }
    }, 0);
});